//----------------------
// <auto-generated>
//     Generated using Aya Client Generator [Version 1.0.2]
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { AcceptanceRuleFieldDisplayTextTargetEnum } from './enums/acceptance-rule-field-display-text-target-enum.enum';
import { API_BASE_URL } from './misc/api-base-url.token';
import { blobToText } from './misc/blob-to-text.function';
import { FileParameter } from './misc/file-parameter.model';
import { FileResponse } from './misc/file-response.model';
import { throwException } from './misc/throw-exception.function';
import { AcceptanceRuleLookupsDto } from './models/acceptance-rule-lookups-dto.model';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class AcceptanceRulesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAcceptanceRuleLookups(documentTypeId: number, displayTextTarget: AcceptanceRuleFieldDisplayTextTargetEnum | undefined, isDocumentSmartDescriptionsEnabled: boolean | null | undefined): Observable<AcceptanceRuleLookupsDto> {
        let url_ = this.baseUrl + "/AyaNova/compliance/acceptance-rules/lookups/{documentTypeId}?";
        if (documentTypeId === undefined || documentTypeId === null)
            throw new Error("The parameter 'documentTypeId' must be defined.");
        url_ = url_.replace("{documentTypeId}", encodeURIComponent("" + documentTypeId));
        if (displayTextTarget === null)
            throw new Error("The parameter 'displayTextTarget' cannot be null.");
        else if (displayTextTarget !== undefined)
            url_ += "displayTextTarget=" + encodeURIComponent("" + displayTextTarget) + "&";
        if (isDocumentSmartDescriptionsEnabled !== undefined && isDocumentSmartDescriptionsEnabled !== null)
            url_ += "isDocumentSmartDescriptionsEnabled=" + encodeURIComponent("" + isDocumentSmartDescriptionsEnabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAcceptanceRuleLookups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAcceptanceRuleLookups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AcceptanceRuleLookupsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AcceptanceRuleLookupsDto>;
        }));
    }

    protected processGetAcceptanceRuleLookups(response: HttpResponseBase): Observable<AcceptanceRuleLookupsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AcceptanceRuleLookupsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}